import { Response } from './client/types'
import { useAPI } from './client/useAPI'

export type CompanyStatsData = {
  id: string
  employeesCount: number
  ordersCount: number
  transactionsCount: number
}

type CompanyStatsResponse = Response<CompanyStatsData>

export const useCompanyStats = (id: string) => {
  return useAPI<CompanyStatsResponse>('GET', `/stats/companies/${id}`, {
    withToken: true,
  })
}
